import Notifications from './Notification';

export default Notifications;
